import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { api } from '../../api/client';
export default function PlanStep({ onAdvance, onChanged }) {
    const [markdown, setMarkdown] = useState('');
    const [draft, setDraft] = useState('');
    const [hasPlan, setHasPlan] = useState(false);
    const [instruction, setInstr] = useState('');
    const [busy, setBusy] = useState('load');
    const [error, setError] = useState(null);
    async function refresh() {
        setBusy('load');
        setError(null);
        try {
            const { has_plan, markdown } = await api.wizardPlanGet();
            setMarkdown(markdown);
            setDraft(markdown);
            setHasPlan(has_plan);
        }
        catch (e) {
            setError(e?.message ?? 'Failed to load');
        }
        finally {
            setBusy(null);
            onChanged();
        }
    }
    useEffect(() => { refresh(); }, []);
    async function run(apply) {
        setBusy('run');
        setError(null);
        try {
            const r = await api.wizardPlanRun(apply, instruction);
            setMarkdown(r.markdown);
            setDraft(r.markdown);
            if (apply) {
                setHasPlan(true);
                onChanged();
            }
        }
        catch (e) {
            setError(e?.message ?? 'Run failed');
        }
        finally {
            setBusy(null);
        }
    }
    async function save() {
        setBusy('save');
        setError(null);
        try {
            await api.wizardPlanSave(draft);
            setMarkdown(draft);
            setHasPlan(true);
            onChanged();
        }
        catch (e) {
            setError(e?.message ?? 'Save failed');
        }
        finally {
            setBusy(null);
        }
    }
    const dirty = draft !== markdown;
    return (_jsxs("div", { className: "step-content", children: [_jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Generate sitemap" }), _jsxs("label", { className: "field", children: [_jsx("span", { children: "Optional instruction to the planner" }), _jsx("textarea", { rows: 3, value: instruction, onChange: (e) => setInstr(e.target.value), placeholder: "Add an industry-specific landing page; emphasize the booking CTA\u2026" })] }), _jsxs("div", { className: "step-foot", children: [_jsx("button", { className: "ghost", onClick: () => run(false), disabled: busy !== null, children: busy === 'run' ? 'Running…' : 'Preview plan' }), _jsx("button", { onClick: () => run(true), disabled: busy !== null, children: busy === 'run' ? 'Running…' : 'Generate & save' })] })] }), _jsxs("section", { className: "card-section", children: [_jsx("h2", { children: "Site plan markdown" }), _jsxs("p", { className: "muted small", children: ["Saved to ", _jsx("code", { children: "site/brand/site-plan.md" }), ". Edit freely; Build pages reads from this."] }), _jsx("textarea", { className: "mono", rows: 20, value: draft, onChange: (e) => setDraft(e.target.value), placeholder: hasPlan ? '' : '(no plan yet — generate above or paste your own)' }), _jsxs("div", { className: "step-foot", children: [_jsx("button", { className: "ghost", disabled: !dirty || busy !== null, onClick: () => setDraft(markdown), children: "Reset" }), _jsx("button", { disabled: !dirty || busy !== null, onClick: save, children: busy === 'save' ? 'Saving…' : 'Save edits' })] })] }), error && _jsx("div", { className: "err small pad-y", children: error }), _jsx("div", { className: "step-foot", children: _jsx("button", { onClick: onAdvance, disabled: !hasPlan, children: "Continue \u2192" }) })] }));
}
